import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./StartOverModal.css";
import { useDispatch } from "react-redux";
import { applicationTitle } from "../../Redux/SetApplicationTitle";

const StartOverModal = ({ showModal, setShowModal }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const confirmButtonRef = useRef(null);
  const cancelButtonRef = useRef(null);

  const returnHandler = () => {
    navigate("/home");
    dispatch(applicationTitle("global.documentTitle"));
  };

  useEffect(() => {
    if (!showModal) return;
    // Only the modal buttons are tabbable
    const focusableElements = [
      confirmButtonRef.current,
      cancelButtonRef.current,
    ];
    // Auto focus the confirm button
    focusableElements[0]?.focus();
    const trapTab = (ev) => {
      // Allow user to cancel via esc key
      if (ev.key === "Escape") {
        setShowModal(false);
      }

      // Get the current activeElement
      const currentIndex = focusableElements.findIndex(
        (element) => element === document.activeElement
      );

      // User is trying to shift+Tab (reverse)
      if (ev.shiftKey) {
        if (currentIndex === 1) {
          ev.preventDefault();
          focusableElements[0]?.focus();
        }
        // User is trying to Tab (forward)
      } else if (ev.key === "Tab") {
        if (currentIndex === 0) {
          ev.preventDefault();
          focusableElements[1]?.focus();
        }
      }
    };

    document.addEventListener("keydown", trapTab);
    return () => {
      document.removeEventListener("keydown", trapTab);
    };
  }, [showModal]);

  return (
    <div className="modalContainer">
      <div className="modal-main">
        <h2 className="cancelTitle" role="alert"
          aria-live="assertive"> {t("cancelModal.title")}</h2>
        <div className="cancelTextContainer" role="alert"
          aria-live="assertive">
          <br></br>
          <p>{t("cancelModal.text")}</p>
          <br></br>
        </div>

        <footer>
          <div className="cancelButtonContainer">
            <button
              className="startOverBtn"
              type="button"
              onClick={() => setShowModal(false)}
              ref={cancelButtonRef}
            >
              {t("button.cancel")}
            </button>
            <button
              className="cancelButtonStyle"
              type="button"
              onClick={() => returnHandler()}
              ref={confirmButtonRef}
            >
              {t("button.confirm")}
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default StartOverModal;
